
import styled from "styled-components";
import { CartDateGroup, DeliveryDetailsModal, TifynFooter } from "@tiffin/components";
import { cartMultiReducer } from "@tiffin/app-common";
import { OrderType } from "@tiffin/core";

import { useAppSelector } from "../hooks";
import TifynLogo from "../assets/images/tifyn-logo.png"
import { NavBar } from "../components/NavBar";
import { ViewContext } from "../Contexts";
import { MenuBar } from "../components/MenuBar";
import { ReactComponent as EmptyCartSVG } from '../assets/images/empty-cart.svg';

import { IonIcon } from "@ionic/react";
import { cartOutline } from "ionicons/icons"
import { useContext, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { OrderDetails } from "../components/cart/OrderDetails";

export const Cart = styled(BaseCart)`
  display: grid;
  grid-template-columns: auto 1fr;
  height: 100%;

  @media (max-width:768px) {
    grid-template-columns: 100%;
  }

  .header {
    background: #fff;
    padding: 20px;
    font-size: var(--font-size-medium);
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 5px;

    ion-icon {
      font-size: var(--font-size-xlarge);
    }
  }

  .page {
    height: calc(var(--vh, 1vh) * 100);
    overflow: auto;
    display: flex;
    flex-direction: column;

    @media (max-width:768px) {
      padding-bottom: 70px;
    }

    .cart-group-items {
      margin: 10px;
      overflow: auto;
      flex-grow: 1;

      .order-details {
        padding: 10px 0;

        @media (max-width:768px) {
          padding: 10px 25px;
        }
      }
    }

    .cart-groups {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .empty-cart {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 20px;
      color: var(--ion-color-medium);
      font-weight: 600;
      margin: 10px;
      background: #fff;
      border-radius: 8px;

      svg {
        width: 100px;
        height: fit-content;
      }
    }
  }
`

interface ICart {
  className?: string
}

function BaseCart({className}: ICart) {

  const partner = useAppSelector((state) => state.store)
  const cart = useAppSelector((state) => partner.details?.id && state.cartMulti.carts[partner.details.id] ? state.cartMulti.carts[partner.details.id] : cartMultiReducer.EmptyCart);
  const cartStatus = useAppSelector((state) => state.cartMulti.status)

  const [showAddressModal, setShowAddressModal] = useState<boolean>(false)
  const navigate = useNavigate()
  const [searchParams] = useSearchParams();
  const view = useContext(ViewContext);

  function renderDateGroup() {
    let items = []
    let dates = cart.items ? Object.keys(cart.items).sort() : [];
    let tableNumber = searchParams.get("table")

    if(partner.details) {
      for (let date of dates) {
        items.push(
          <CartDateGroup 
            key={date}
            date={date}
            partner={partner.details}
            cart={cart}
            addMoreItemsCallback={() => {
              navigate({pathname: `/${partner.details?.urlName}`, search: searchParams.toString()})
            }}
            checkoutCallback={() => {
              navigate({pathname: `/${partner.details?.urlName}/checkout/${encodeURIComponent(date)}`, search: searchParams.toString()})
            }}
            isPartnerWebsite={true}
            tableNumber={tableNumber ? parseInt(tableNumber) : undefined}
          />)
      }
    }
    return items
  }

  return (
    <div className={className}>
      {
        view === "web" && <NavBar />
      }
      <div className="page" style={{paddingBottom: view === "mobile" ? 70 : 0}}>
        {
          partner.details &&
          <>
            <div className="header">
              <IonIcon icon={cartOutline} />
              <span>{cart.orderType === OrderType.Pickup ? "Pickup Details" : "Delivery Details"}</span>
            </div>
            {cart.items && Object.keys(cart.items).length > 0 && (
              <div className="cart-group-items">
                <div className="order-details">
                  <OrderDetails showDeliveryWarning={true} />                  
                </div>
                <div className="cart-groups">{renderDateGroup()}</div>
              </div>
            )}
            {(!cart.items || Object.keys(cart.items).length === 0) && (
              <div className="empty-cart">
                <EmptyCartSVG />
                <span>You have no items in your cart</span>
              </div>
            )}
            {
              view === "web" &&
              <TifynFooter
                logoAlt="Tifyn Logo"
                logoSrc={TifynLogo}
              />
            }
          </>
        }
      </div>
      {
        view === "mobile" && <MenuBar />
      }
      {
        partner.details?.id &&
        <DeliveryDetailsModal
          isOpen={showAddressModal}
          onCancel={() => setShowAddressModal(false)}
          hideDatePicker={true}
          onAddressChange={() => setShowAddressModal(false)}
          cart={cart}
          cartStatus={cartStatus}
          isPartnerWebsite={true}
          partner={partner.details}
        />
    }
    </div>
  )
}